import DefectCheckingRow from './DefectCheckingRow';

export default DefectCheckingRow;
